import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FADE_DURATION, getSpreadDescription } from '../imageViewerUtils';
import { useMediaTitle } from './MediaFrame';

/**
 * Footer component displaying image description
 * Supports fade transition for smooth description changes
 */
const ImageViewerFooter = forwardRef(({ 
    description, 
    fadeOut, 
    fadeOpacity,
}, ref) => {
    const title = useMediaTitle();
    // Get the description for the fade out overlay
    // Use spread description if fading out from a spread, otherwise use single image description
    const fadeOutDescription = fadeOut 
        ? (fadeOut.slideData?.type === 'spread' 
            ? getSpreadDescription(fadeOut.slideData) 
            : fadeOut.imageData?.description || '')
        : '';

    return (
        <footer 
            className="absolute bottom-[20px] md:bottom-[19px] left-0 right-0 flex items-center justify-center px-12" 
            style={{ zIndex: 20 }}
        >
            {/* Description text - shows old description during fade, new description after */}
            <div className="text-center">
                <span 
                    ref={ref}
                    data-header-module={title.id}
                    data-lock-ratio="0"
                    className={title.active ? '' : 'media-caption uppercase tracking-[0.15em]'}
                    style={{ 
                        color: title.active ? undefined : 'var(--color-text)',
                        opacity: fadeOut ? fadeOpacity : 1,
                        transition: `opacity ${FADE_DURATION}ms ease-in-out`,
                        ...title.style,
                    }}
                >
                    {fadeOut ? fadeOutDescription : (description || '')}
                </span>
            </div>
        </footer>
    );
});

ImageViewerFooter.displayName = 'ImageViewerFooter';

ImageViewerFooter.propTypes = {
    description: PropTypes.string,
    fadeOut: PropTypes.object,
    fadeOpacity: PropTypes.number,
};

export default ImageViewerFooter;
